@if(isDisabled){
<app-loader></app-loader>
}
<div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button [routerLink]="['/master/userdetail/applicability/', 0]" class="btn btn-primary btn-sm">+ Add Applicability</button>
            </div>
        </div>
<div class="card mt-2">
    <div class="card-header">
        User Applicability
    </div>
    <div class="card-body">
        <div class="mt-3" style="overflow: auto;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;">Action</th>
                        <th>UserName</th>
                        <th>Applicability</th>
                        <th>Active</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="font-size: 11px;" *ngFor="let e of TableData ;let i = index">
                        <td>
                            <span style="width: max-content;" class="d-block">{{i+1}}</span>
                        </td>
                        <td style="text-align: center;">
                            <span style="width: max-content;" class="d-block">
                                <i [routerLink]="['/master/userdetail/applicability/',e['UserMasterID']]"
                                    class="bi bi-pencil-square text-warning cursor-pointer"></i>
                            </span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">{{e['UserName']}}</span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">
                                {{GetApplicabilityName(e['WebESSUserApplicabilityMasterId'])}}
                            </span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">
                                @if(e['Active']){
                                <span class="badge text-bg-success">Yes</span>
                                }@else{
                                <span class="badge text-bg-danger">No</span>
                                }
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>